import { Component, EventEmitter, Output } from '@angular/core';
import { TransactionFacade } from '../../../models/transactions/transactionFacade';
import { TransactionService } from '../../../models/transactions/transactionService';
import {
  Page,
  TableViewAbstractComponent,
} from '../../ui/filterable-table/tableViewAbstractComponent';
import { SearchFilters } from '../../../models/search/searchFilters';
import { UIHelpers } from '../../../core/ui-helpers';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AccessManager } from '../../ui/access-manager/access-manager';

@Component({
  selector: 'app-order-details-table-view',
  templateUrl: './order-details-table-view.component.html',
  standalone: false,
})
export class OrderDetailsTableViewComponent extends TableViewAbstractComponent {
  hideMID: boolean = false;
  selectedTransactions: TransactionFacade[] = [];
  allowEditTransactions: boolean = false;
  loading: boolean = true;

  constructor(
    public transactionService: TransactionService,
    private uiErrorHandler: UIErrorHandler,
    private dialog: MatDialog,
    private router: Router,
    private accessManager: AccessManager,
  ) {
    super();
  }

  async ngOnInit() {
    const access = await this.accessManager.getUserAccess(AccessManager.AUTH_INSERT_MERCHANT_TRANSACTIONS);
    this.allowEditTransactions = access[AccessManager.AUTH_INSERT_MERCHANT_TRANSACTIONS];
  }

  getRecordFromDataSource(transactionId: string): TransactionFacade {
    for (var i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i].id == transactionId) {
        return this.dataSource.data[i];
      }
    }

    throw 'Transaction not found in dataset';
  }

  getPageOfData(
    query: string,
    filters: SearchFilters,
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
  ): Promise<Page<TransactionFacade>> {
    if (
      this.options.hiddenFields &&
      this.options.hiddenFields.includes('MID')
    ) {
      this.hideMID = true;
    }

    return this.transactionService
      .getPaged(query, {
        pageNum: pageNum,
        pageSize: pageSize,
        orderBy: 'name',
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        userId: this.options.userId ? this.options.userId : '',
        restrictToAction: this.options.restrictToAction,
        //allowRefund: this.options.allowRefund,
        merchantId: this.options.merchantId ? this.options.merchantId : '',
        customerId: this.options.customerId ? this.options.customerId : '',
        orderId: this.options.orderId ? this.options.orderId : '',
        invoiceNumber: this.options.invoiceNumber
          ? this.options.invoiceNumber
          : '',
        month: this.options.month ? this.options.month : '',
        year: this.options.year ? this.options.year : '',
      })
      .then((response) => {
        this.genericOutputEvent.emit({
          message: 'Table data loaded',
          loaded: true,
        });
        return response;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
        return new Page<TransactionFacade>({});
      }).finally(() => this.loading = false);
  }

  canQuery(): boolean {
    if (this.options) {
      return (
        (this.options && this.options.merchantId != undefined) ||
        this.options.customerId != undefined ||
        this.options.userId != undefined
      );
    }
    return false;
  }

  onCheckboxChange(item: TransactionFacade) {
    if (this.selectedTransactions.includes(item)) {
      this.selectedTransactions = this.selectedTransactions.filter(t => t.id !== item.id);
    } else {
      this.selectedTransactions.push(item);
    }
    this.genericOutputEvent.emit({
      message: 'Selected transactions changed',
      selectedTransactions: this.selectedTransactions,
    });
  }

  formatDate(
    date: string | undefined,
    defaultText: string | undefined,
  ): string {
    if (date) {
      return UIHelpers.formatDate(date);
    } else {
      return defaultText + '';
    }
  }
}
